const CLICK_ACTION = {
    ACTION: 'ACTION',
    LINK: 'LINK',
    NOTHING: 'NOTHING',
    MAGNIFY: 'MAGNIFY',
};
export default CLICK_ACTION;
//# sourceMappingURL=behaviourParams_item_clickAction.js.map